import React, { useState } from 'react';
import Header from './components/Header';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Navbar from './components/Navbar';
import LayoutSetting from './components/LayoutSetting';
import Dashboard from './pages/Dashboard';
import Page404 from './pages/Page404';
import Login from './pages/Login';
import Users from './pages/Users';

import 'react-toastify/dist/ReactToastify.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Appointments from './pages/Appointments';
import Partners from './pages/Partners';
import Partner from './pages/Partner';
import Subscribers from './pages/Subscribers';
import Propdesks from './pages/Propdesks';
import Stock from './pages/Stock';
import Home from './pages/Home';
import Products from './pages/Products';
import SelectedProducts from './pages/SelectedProducts';
import DematUsers from './pages/DematUsers';
import Payouts from './pages/Payouts';
import Achievements from './pages/Achievements';
import Ads from './pages/Ads';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(open => !open);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="GleamDesk-admin">
      <BrowserRouter>
        <ToastContainer />
        <Header toggleSidebar={toggleSidebar} />
        <Navbar sidebarOpen={sidebarOpen} closeSidebar={closeSidebar} />
        <LayoutSetting />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/users" element={<Users />} />
          <Route exact path="/demat-users" element={<DematUsers />} />
          <Route exact path="/appointments" element={<Appointments />} />
          <Route exact path="/payouts" element={<Payouts />} />
          <Route exact path="/partners" element={<Partners />} />
          <Route exact path="/achievements" element={<Achievements />} />
          <Route exact path="/ads" element={<Ads />} />
          <Route exact path="/partner/:id" element={<Partner />} />
          <Route exact path="/products" element={<Products />} />
          <Route exact path="/selected-products" element={<SelectedProducts />} />
          <Route exact path="/subscribers" element={<Subscribers />} />
          <Route exact path="/propdesks" element={<Propdesks />} />
          <Route exact path="/stock" element={<Stock />} />
          <Route exact path="*" element={<Page404 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
